import Send01 from '@untitled-ui/icons-react/build/esm/Send01';

import { Tooltip } from 'antd';
import { useRenewVerificationMutation } from 'api/IndividualsApiSlice';
import { ModalComponent, useModal } from 'components/Modal';
import { useToast } from 'providers/ToastProvider';
import { BaseButton } from './BaseButton';

interface RecordType {
  status?: string;
  id?: string;
}

interface RenewVerificationButton {
  record: RecordType;
}

export const RenewVerificationButton = ({ record }: RenewVerificationButton) => {
  const [renewVerification, { isLoading }] = useRenewVerificationMutation();
  const { openModal, closeModal } = useModal();
  const toast = useToast();

  if (record?.status !== 'Expired') {
    return null;
  }

  const modalBodyText =
    'Renewing this verification will generate a new verification link and incur a fee. Do you wish to continue?';

  const handleRenewVerification = async () => {
    closeModal();

    if (!record.id) {
      return;
    }

    try {
      await renewVerification(record.id).unwrap();

      toast.success('Verification link created!');
    } catch {
      toast.error('Could not renew the verification.');
    }
  };

  const handleDisplayModal = () => {
    openModal(
      <ModalComponent
        bodyContent={modalBodyText}
        onCancel={closeModal}
        onUpdate={handleRenewVerification}
        buttonText="Renew Verification"
      />,
      'Renew Verification'
    );
  };

  return (
    <Tooltip title="Renew Verification">
      <BaseButton
        className="secondary-button min-h-8 min-w-8"
        icon={<Send01 className="h-4 w-4" />}
        loading={isLoading}
        onClick={handleDisplayModal}
      />
    </Tooltip>
  );
};

export default RenewVerificationButton;
